
import { TOAST } from '@commoncore/constants/ToastMessages';
import { TeamFolderService } from '@commoncore/services/team-folder.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { SharedFilesListImplementation } from '@mainrepo/app/core/implementation/SharedFilesListImplementation';
import { CustomSortService } from '../services/custom-sort.service';
import { LocalStorageSvc } from '../services/localStorage.service';
import { IndexDBImplementation } from './IndexDBImplementation';

export class CreateFolderImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public listService: any;
  contextMenuService: any;
  customMetadata: any;
  customSort: any;
  public sortOrder: any;
  public updateList: boolean = false;
  loggerService: any;
  folderViewImplf: any;
  foldersController: any;
  sharedFileListImpl: any;
  globalService: any;
  localStorageSvc: LocalStorageSvc;
  db: IndexedDBModule;
  indexDBData: any = "";
  cacheImpl: IndexDBImplementation;
  static singleInstance: any = null;
  teamFolderService: any;
  readonly deskFoldersCount : number = 12;
  readonly mobFoldersCount: number = 3;

  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
  }

  public static getInstance(globalService): CreateFolderImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new CreateFolderImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }



  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.route = globalService.getActivatedRoute();
    this.listService = globalService.getListServiceRef();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.loggerService = globalService.getLoggerServiceRef();
    this.sharedFileListImpl = SharedFilesListImplementation.getInstance(globalService);
    this.globalService = globalService;
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.db = IndexedDBModule.getInstance(globalService)
    this.cacheImpl = IndexDBImplementation.getInstance(globalService)
    this.teamFolderService = new TeamFolderService();
  }

  async updateCreatedFolderInView(newFolderMetadata){
    if (newFolderMetadata.parentObjectKey == USER_DETAILS["USER_DETAILS"]["rootFolderKey"]){
        await this.cacheImpl.addFolderIndexDB([this.universalService.createFolderApiResponse])
    }
    this.folderViewImplf.folderShownCount = this.getFolderToShowCount();
    setTimeout(()=>{
      AppEvents.optionSelected.next({"folderCreated":true,object:newFolderMetadata,expandFolderSection:true});
    },600)
    this.showCreatedSuccessMessage(newFolderMetadata["objectName"])
  }


  getFolderToShowCount(){
    return this.universalService.isMobileDevice ? this.mobFoldersCount :  this.deskFoldersCount;
  }
  showCreatedSuccessMessage(folderName) {
    this.listService.deSelectAll();
    var quote = " \" ";
    let msg = "Folder " + quote + folderName + quote + " created successfully."
    if(this.router.url.includes("/home"))
      msg = msg + TOAST["ACCESSS_FROM_MYFILES_SINGLE_FILE"]

    this.universalService.showToast(msg, "success");
  }









}